import { render, staticRenderFns } from "./FutureContractSpecs.vue?vue&type=template&id=2fceb199&scoped=true&"
import script from "./FutureContractSpecs.vue?vue&type=script&lang=js&"
export * from "./FutureContractSpecs.vue?vue&type=script&lang=js&"
import style0 from "./FutureContractSpecs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FutureContractSpecs.vue?vue&type=style&index=1&id=2fceb199&lang=scss&scoped=true&"
import style2 from "./FutureContractSpecs.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fceb199",
  null
  
)

export default component.exports